import { combineReducers } from "redux";
import { ReduxAction } from "types/redux";
import accountReducer from "./account.reducer";
import appInfoReducer from "./app-info.reducer";
import customersReducer from "./customers.reducer";
import brikReducer from "./brik.reducer";
import appReducer from "./app.reducer";
import recipeReducer from "./recipe.reducer";
import excerciseReducer from "./exercise.reducer";

//v1
import { alert } from "./alert.reducer";
import { USER } from "../../constants/user.constants";
import { courses } from "./courses.reducer";
import { profileBilling } from "./profile-billing.reducer";
import { confirmCode } from "./confirm-code.reducer";
import { forgotPassword } from "./forgot-password.reducer";
import { register } from "./register.reducer";
import { resetPassword } from "./reset-password.reducer";
import { subscription } from "./subscription.reducer";
import { user } from "./user.reducer";
import { dashboard } from "./dashboard.reducer";
import { payment } from "./payment.reducer";
import domainReducer from "./domain.reducer";

const appReducers = combineReducers({
  //v2
  app: appReducer,
  appInfo: appInfoReducer,
  account: accountReducer,
  customers: customersReducer,
  brik: brikReducer,
  recipe: recipeReducer,
  exercise: excerciseReducer,
  dashboard: dashboard,
  payment: payment,

  //v1
  alert: alert,
  courses: courses,
  profileBilling: profileBilling,
  user: user,
  confirmCode: confirmCode,
  forgotPassword: forgotPassword,
  resetPassword: resetPassword,
  register: register,
  subscription: subscription,
  domain: domainReducer,
});

const rootReducer = (state: any, action: ReduxAction) => {
  if (action.type === USER.LOGOUT_SUCCESS) {
    state = undefined;
  }
  return appReducers(state, action);
};

export type RootState = ReturnType<typeof appReducers>;

export default rootReducer;
